module.exports = require('platformClient');